import moment from 'moment'
import 'moment/locale/es-mx'
import { MIN_DATE } from '@/utils/minDatesFilters'

export default {
  install(Vue) {
    Vue.prototype.$MIN_DATE = MIN_DATE
    Vue.prototype.$MAX_DATE = moment().format('YYYY-MM-DD')
    Vue.$moment = moment
    Object.defineProperty(Vue.prototype, '$moment', {
      get () {
        return moment
      }
    })
  }
}
